import { render, staticRenderFns } from "./line-pricing-group-dialog.vue?vue&type=template&id=ed65cad0&scoped=true"
import script from "./line-pricing-group-dialog.vue?vue&type=script&lang=js"
export * from "./line-pricing-group-dialog.vue?vue&type=script&lang=js"
import style0 from "./line-pricing-group-dialog.vue?vue&type=style&index=0&id=ed65cad0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed65cad0",
  null
  
)

export default component.exports